/**
 * Mainbeauty — thẻ webinar trên trang danh sách.
 *
 * Hai việc nhỏ, cả hai đều thuần trình bày; trạng thái và số chỗ THẬT do server dựng sẵn
 * trong markup, JS không tính lại cái nào.
 */

/**
 * Thanh "chỗ đã giữ" chạy từ 0 tới tỉ lệ thật khi thẻ lọt vào màn hình.
 *
 * Bề rộng để trong `data-pi-fill` chứ không phải style inline vì luật của project cấm
 * style="…" trong PHP template — và tiện thể, nhờ vậy mới có hiệu ứng chạy.
 */
function initSeatBars() {
  const bars = document.querySelectorAll("[data-pi-fill]");
  if (!bars.length) return;

  const fill = (el) => {
    const pct = Math.max(0, Math.min(100, parseInt(el.getAttribute("data-pi-fill"), 10) || 0));
    el.style.width = `${pct}%`;
  };

  // Không có IntersectionObserver (trình duyệt cũ) thì đổ đầy ngay — mất hiệu ứng, không mất số liệu.
  if (!("IntersectionObserver" in window)) {
    bars.forEach(fill);
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        fill(entry.target);
        io.unobserve(entry.target);
      });
    },
    { rootMargin: "0px 0px -10% 0px" }
  );

  bars.forEach((bar) => io.observe(bar));
}

/**
 * Đồng hồ trên thẻ đếm về 0 trong lúc người dùng đang mở trang: thay dãy số bằng một dòng chữ.
 *
 * KHÔNG tự đổi thẻ sang "đang diễn ra": buổi bắt đầu lúc nào là việc của server, và một thẻ
 * tự phong LIVE rồi mời bấm vào phòng trong khi phòng chưa mở là hứa suông với khách.
 */
function initCountdownEnd() {
  const cards = document.querySelectorAll(".pi-wcard__cd[data-pi-countdown]");
  if (!cards.length) return;

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      const node = record.target;
      if (!node.classList.contains("is-ended")) return;
      node.textContent = "Sắp bắt đầu — tải lại trang để vào phòng";
      observer.disconnect();
    });
  });

  cards.forEach((card) => observer.observe(card, { attributes: true, attributeFilter: ["class"] }));
}

/**
 * Lịch chọn tháng đóng lại khi bấm ra ngoài hoặc bấm Esc.
 *
 * Chỉ có thế: hộp là một <details> và mỗi tháng bên trong là link thật, nên tắt JS thì nó vẫn
 * mở ra và vẫn lọc được — mất đúng cái tiện, không mất chức năng nào.
 */
function initMonthPicker() {
  const picks = document.querySelectorAll("[data-pi-monthpick]");
  if (!picks.length) return;

  const closeAll = (except) => {
    picks.forEach((pick) => {
      if (pick !== except) pick.removeAttribute("open");
    });
  };

  document.addEventListener("click", (e) => {
    const inside = e.target.closest("[data-pi-monthpick]");
    closeAll(inside);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    closeAll(null);
  });
}

// Chip trạng thái không cần JS: mỗi ô là một link mang sẵn trạng thái mới trên URL.
document.addEventListener("DOMContentLoaded", () => {
  initSeatBars();
  initCountdownEnd();
  initMonthPicker();
});
